<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import type { LimitedOrderingProductRequest } from "@shared/types/LimitedOrderingProductRequest";

  export let request: LimitedOrderingProductRequest;
  export let show: boolean;
  export let onClose;
</script>

<div class="fizz-styles">
  <Modal closeOnBackgroundClick={false} fizzModal={true} medium={true} bind:show>
    <div class="layout-header-footer">
      <header class="fizz-modal-header">
        <h4 class="fizz-heading-4">Request Note</h4>
        <button type="button" class="fizz-modal-toggle fizz-modal-close" on:click={onClose}>
          <Icon type="X" height={14} width={14} />
        </button>
      </header>
      <section class="fizz-modal-main fizz-text-medium fizz-flow-16" data-grid-area="main">
        <p
          >{request.requested_by_user.full_name}
          sent the following message with their request:
          <br />
          <strong>"{request.request_note}"</strong></p
        >

        {#if request.approval_note}
          <p
            >{request.addressed_by_user.full_name}
            responded to their request: <br />
            <strong>"{request.approval_note}"</strong>
          </p>
        {/if}
      </section>
      <footer class="fizz-modal-footer fizz-flex-row fizz-justify-end">
        <button type="button" class="fizz-button-secondary fizz-modal-toggle" on:click={onClose}>
          OK
        </button>
      </footer>
    </div>
  </Modal>
</div>
